import { render, staticRenderFns } from "./stops-list.vue?vue&type=template&id=bffadf16"
import script from "./stops-list.vue?vue&type=script&lang=js"
export * from "./stops-list.vue?vue&type=script&lang=js"
import style0 from "./stops-list.vue?vue&type=style&index=0&id=bffadf16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports